import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => {
  return ({
    container: {
      margin: '24px 40px',
    },
    headerWrapper: {
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '24px 40px',
      height: '100%'
    },
    title: {
      color: '#335977',
      fontSize: '30px',
      fontWeight: 'bold'
    },
    cardWrapper: {
      margin: '24px 40px',
      padding: '20px'
    },
    buttonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start'
    },
    buttons: {
      width: 'auto',
      minWidth: '150px',
      minHeight: '36px',
      margin: '10px 0'
    },
    iconButtons: {
      width: 'auto',
      margin: '10px 0'
    },
    mr4: {
      marginRight: '10px'
    },
    noXMargin: {
      marginLeft: '0px',
      marginRight: '0px'
    },
    nameInTable: {
      minWidth: 200,
      wordBreak: 'break-word'
    },
    idInTable: {
      minWidth: 120
    },
    capacityInTable: {
      paddingLeft: '120px'
    },
    centerAlign: {
      textAlign: 'center'
    },
    link: {
      color: '#026AE3',
      textDecoration: 'none',
      cursor: 'pointer'
    },
    customDot: {
      width: 10,
      height: 10,
      margin: '0 8px',
      color: '#7F7F7F',
      opacity: 0.5,
      backgroundColor: '#7F7F7F',
      borderRadius: '50%',
      cursor: 'pointer',
    },
    customDotActive: {
      width: 20,
      height: 20,
      opacity: 1,
      margin: '0 8px',
      backgroundColor: '#F37320',
      borderRadius: '50%',
      transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    },
    stepperDots: {
      alignItems: 'center',
    },
    stepperContent: {
      padding: 16,
      textAlign: 'center',
      fontSize: '16px',
      color: '#000000',
    },
    stepperLink: {
      color: '#F37320',
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    stepperNumberImg: {
      position: 'absolute',
      top: '20px',
      left: '20px',
    },
    stepperImg: {
      margin: '10px 50px',
      width: '100%',
      maxWidth: '250px',
      height: '165px',
    },
    secondaryText: {
      fontSize: '14px',
      color: '#000000',
      opacity: 0.5,
      textAlign: 'center'
    },
    fileModalText: {
      fontSize: '14px',
      color: '#565657'
    },
    fileModalIcon: {
      cursor: 'pointer'
    },
    customPaper: {
      maxWidth: '700px'
    },
    buttonIcons: {
      verticalAlign: 'middle'
    },
    round: {
      borderRadius: '50%',
      width: '8px',
      height: '8px',
    },
    progressText: {
      color: '#4A4A4A',
      fontSize: '13px',
      minWidth: '35px',
      whiteSpace: 'nowrap'
    },
    rejectedBar: {
      borderRadius: 5,
      backgroundImage: 'linear-gradient(-45deg,hsla(0,0%,100%,1) 0%,transparent 0,transparent 50%,hsla(0,0%,100%,1) 0,hsla(0,0%,100%,.5) 75%,transparent 0,transparent)',
      backgroundSize: '5px 5px'
    },
    noticeText: {
      color: '#000000',
      opacity: '50%'
    },
    programClosureImage: {
      width: '140px',
    },
    programClosureTitle: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      fontSize: '22px',
      fontWeight: 600,
      color: '#4A4A4A',
      margin: '24px 0'
    },
    programClosureDescription: {
      textAlign: 'justify',
      fontSize: '14px',
      color: '#4A4A4A',
      margin: '8px 0',
      padding: '0 5px'
    },
    programClosureText: {
      background: 'rgba(243,115,31,0.07) 0% 0% no-repeat padding-box',
      borderRadius: '15px',
      color: '#F37320',
      fontSize: '12px',
      cursor: 'pointer'
    }
  })
})

export { useStyles }
